import { Stack } from "@mui/material";
import ThemeContext from "components/app/Context";
import KeyMetrics from "components/common/KeyMetrics/KeyMetrics";
import { useTranslate } from "hooks/useTranslate";
import { useContext } from "react";

import "./index.scss";

const Snapshot = (props: any) => {
  const translate = useTranslate();
  const { planSnapshotData, actionSnapshotData } = props;
  const { isMobileScreen } = useContext(ThemeContext);

  const getMetricsDataForCard = (data: any) => {
    if (data) {
      return [
        {
          isPrimary: true,
          title: translate("common.completed"),
          subTitle: translate("common.pastDays"),
          data: data?.completedLast90Days
        },
        {
          subTitle: translate("common.totalActive"),
          data: data?.active,
          showBorder: true
        },
        {
          subTitle: translate("common.overdue"),
          data: data?.overdue
        }
      ];
    }
    return [];
  };

  return (
    <>
      <Stack
        direction={isMobileScreen ? "column" : "row"}
        marginTop={"32px"}
        spacing={2}
        className="snapshot-component"
      >
        <KeyMetrics label={translate("dashboard.PlanLabel")} keyMetricsData={getMetricsDataForCard(planSnapshotData)} />
        <KeyMetrics
          label={translate("dashboard.actionsLabel")}
          keyMetricsData={getMetricsDataForCard(actionSnapshotData)}
        />
      </Stack>
    </>
  );
};

export default Snapshot;
